export default __webpack_public_path__ + "static/media/title.ab389a24.png";